import { render } from "./CollectionForAccountingTable.vue?vue&type=template&id=132c4b3f&scoped=true"
import script from "./CollectionForAccountingTable.vue?vue&type=script&lang=js"
export * from "./CollectionForAccountingTable.vue?vue&type=script&lang=js"

import "./CollectionForAccountingTable.vue?vue&type=style&index=0&id=132c4b3f&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132c4b3f"]])

export default __exports__